
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_1u0sx_145",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_1u0sx_180",
  "ghost": "awsui_ghost_d19fg_1u0sx_191",
  "item": "awsui_item_d19fg_1u0sx_196",
  "ghost-item": "awsui_ghost-item_d19fg_1u0sx_197",
  "ellipsis": "awsui_ellipsis_d19fg_1u0sx_198",
  "hide": "awsui_hide_d19fg_1u0sx_209",
  "visible": "awsui_visible_d19fg_1u0sx_215",
  "icon": "awsui_icon_d19fg_1u0sx_219",
  "breadcrumbs-skeleton": "awsui_breadcrumbs-skeleton_d19fg_1u0sx_225",
  "collapsed-button": "awsui_collapsed-button_d19fg_1u0sx_229",
  "button-icon": "awsui_button-icon_d19fg_1u0sx_311",
  "button-icon-open": "awsui_button-icon-open_d19fg_1u0sx_325",
  "hidden": "awsui_hidden_d19fg_1u0sx_329"
};
  